import React from "react";
import Planningtrip from "../assets/images/Planningtrip.png";
import Scroll from "../assets/images/scroll.svg";
import { Link } from "react-router-dom";

interface PlanningTripProps {
  headingplanning: string;
  paragraph: string;
}

const PlanningTrip: React.FC<PlanningTripProps> = ({
  headingplanning,
  paragraph,
}) => {
  return (
    <section className="mt-8 sm:mt-12">
      <div className="relative w-screen">
        <img
          src={Planningtrip}
          alt="Seamless Travel"
          className="w-full h-[200px] sm:h-[300px] md:h-[370px] lg:h-[400px] object-cover"
        />

        <div className="absolute inset-0 flex flex-col justify-center items-center text-center text-white px-4 sm:px-8">
          <h1 className="text-base sm:text-2xl md:text-4xl lg:text-xl font-akshar uppercase tracking-wide font-bold mb-2 leading-tight sm:leading-snug">
            {headingplanning}
          </h1>
          <p className="text-xs sm:text-lg md:text-xl lg:text-lg uppercase font-poppins tracking-wide leading-relaxed  sm:mt-4 mb-2">
            {paragraph}
          </p>
          <button className="mt-3">
            <Link
              to="/go/"
              className=" py-2 sm:py-3 px-4 sm:px-6 md:px-8 uppercase border border-white text-white font-bold tracking-wide rounded-md text-xs sm:text-sm md:text-base lg:text-lg   transition"
            >
              Plan my trip
            </Link>
          </button>
        </div>
      </div>
    </section>
  );
};

export default PlanningTrip;
